(function() {
'use strict';

angular
    .module('TR')
    .controller('TestPage', TestPage);

function TestPage() {
    const cm = this;


    cm.fruits = [];


    cm.selectedMammals = [];

    cm.activeTabId = 'cakes';

    cm.mammals = [
        {
            Value: 1,
            Text: 'Bear'
        },
        {
            Value: 2,
            Text: 'Marmot'
        },
        {
            Value: 3,
            Text: 'Porcupine'
        }
    ];
}
})();
